import { connect } from 'react-redux'
import actions from 'actions/additionalResources'
import Component from 'components/AdditionalResources'

export default connect(null, { getItems: actions.getItems })(Component)
